import React from 'react';
import useTranslation from '../../hooks/useTranslation';

/**
 * Barra de ações padronizada para efeitos
 * Usado por todos os efeitos para manter consistência
 */
const EffectActionBar = ({ 
  onReset, 
  onApply, 
  isResetDisabled = false, 
  isApplyDisabled = false,
  resetText = null,
  applyText = null 
}) => {
  const { t } = useTranslation();

  return (
    <div className="p-4 border-t" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
      <div className="flex items-center justify-end gap-3">
        {/* Botão Resetar - sem fundo */}
        <button
          onClick={onReset}
          disabled={isResetDisabled}
          className="px-4 py-2 text-white hover:opacity-80 transition-colors font-medium text-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {resetText || t('effects.resetFilters')}
        </button>

        {/* Botão Aplicar - com fundo verde */}
        <button
          onClick={onApply}
          disabled={isApplyDisabled}
          className="px-4 py-2 rounded-md transition-colors font-medium text-sm disabled:opacity-50 disabled:cursor-not-allowed"
          style={{ backgroundColor: '#96c925', color: '#000' }}
        >
          {applyText || t('effects.applyFilter')}
        </button>
      </div>
    </div>
  );
};

export default EffectActionBar;
